import React from 'react';
import '../styles/Navbar.css';
import { TokenService } from '../services/tokenService';

interface NavbarProps {
  activeItem: string;
  onNavigate: (item: string) => void;
  onTokenCleared?: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ activeItem, onNavigate, onTokenCleared, isCollapsed, onToggleCollapse }) => {
  const navItems = [
    { id: 'ruleset-audit', label: 'Ruleset Audit' },
    { id: 'workspace-heuristics-audit', label: 'Workspace Heuristics Audit' },
    // Future nav items can be added here
  ];

  const handleClearToken = () => {
    TokenService.clearToken();
    if (onTokenCleared) {
      onTokenCleared();
    }
  };

  const hasToken = TokenService.hasValidToken();

  return (
    <nav className={`navbar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-brand">
          <img src="/fleeferlogo.png" alt="Fleefer Logo" className="navbar-logo" />
          {/* <span className="navbar-title">Fleefer</span> */}
        </div>
        
        <button 
          className="navbar-toggle"
          onClick={onToggleCollapse}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? '▶' : '◀'}
        </button>
        
        <div className="navbar-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`nav-item ${activeItem === item.id ? 'active' : ''}`}
              onClick={() => onNavigate(item.id)}
              title={isCollapsed ? item.label : undefined}
            >
              {isCollapsed ? item.label.charAt(0) : item.label}
            </button>
          ))}
        </div>

        {/* Clear Token Button at bottom */}
        {hasToken && (
          <div className="navbar-footer">
            <button
              onClick={handleClearToken}
              className="nav-item clear-token-btn"
              title={isCollapsed ? "Logout" : "Logout"}
            >
              {isCollapsed ? '🚪' : '🚪 Logout'}
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 
